export default __webpack_public_path__ + "static/media/480_portfolio04-en-mobile.55c63c7e.png";